import React from 'react';
import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { SAGE, CREAM } from '../../theme';

const F = "'Outfit', sans-serif";

/**
 * AddSectionTile — the dashed "+ Add a section" tile that sits at the
 * bottom of the dashboard. Signals to the user that the page is theirs
 * to arrange. Phase 0: visual only.
 */
const AddSectionTile = ({ onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      bgcolor: `${CREAM[50]}60`,
      borderRadius: 3,
      border: `2px dashed ${SAGE[200]}`,
      py: 2.5,
      cursor: onClick ? 'pointer' : 'default',
      transition: 'all 0.15s',
      '&:hover': onClick
        ? { borderColor: SAGE[400], bgcolor: `${CREAM[50]}` }
        : {},
    }}
  >
    <AddIcon sx={{ fontSize: 18, color: SAGE[400] }} />
    <Typography sx={{ fontFamily: F, fontSize: '0.78rem', fontWeight: 500, color: SAGE[500] }}>
      Add a section
    </Typography>
  </Box>
);

export default AddSectionTile;
